<template>
	<div class="addProduct-container">
		<div class="select-box">
			<div>
				店铺级大类：
				<el-select v-model="bcId" class="input-box" size='small' @change="bcChange">
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in bc">
						<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
					</template>
				</el-select>
			</div>
			<div v-if="bigcategoryview === 1" style="margin-left: 10px;">
				店铺级小类：
				<el-select v-model="scId" class="input-box" size='small'>
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in sc">
						<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
					</template>
				</el-select>
			</div>
			<div style="margin-left: 10px;">
				商品信息：
				<el-input v-model="productFilterStr"  size='mini' class='input-box'></el-input>
			</div>
			<el-button style="margin-left: 10px;" type="primary" size="mini" @click='searchClick'>查询</el-button>
			<el-button style="margin-left: 10px;" size="mini" plain @click='clearClick'>清空</el-button>
		</div>
		<div class="select-box">
			<div>
				规格信息：
				<el-input v-model="specFilterStr"  size='mini' class='input-box'></el-input>
			</div>
		</div>
		<div style="margin: 10px 0px;">
			<el-checkbox class="margin10" v-model="checked"></el-checkbox>
			<span class="margin10">统一设置提成规则</span>
			<el-select class="margin10" v-model="commissionType" @change="commissiontypeChange1" style="width: 100px;" size='small'>
				<el-option :value="1" label="百分比"></el-option>
				<el-option :value="2" label="固定金额"></el-option>
			</el-select>
			<el-input class="margin10" size="mini" style="width: 150px;" @input='commissionvalueCheck1' v-model="commissionValue">
				<template slot="prepend">{{commissionType === 1 ? '%' : '￥'}}</template>
			</el-input>
			<span class="margin10">
				<i class="el-icon-info"></i>
				勾选统一设置提成后，列表内编辑内容失效，使用统一设置提成规则进行保存
			</span>
		</div>
		<div class="table-box">
			<el-table
				:stripe='true'
				size='mini'
				class="grid-content"
				:data="tableData"
				:height="tableHeight"
				@selection-change="handleSelectionChange"
				border>
				<el-table-column
				type="selection"
				align="center"
				width="55">
				</el-table-column>
				<el-table-column
					prop="productname"
					label="商品名称"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					prop="spec"
					label="规格"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					prop="commissiontype"
					label="提成规则"
					align="center"
					min-width="180">
					<template slot-scope="scope">
						<div v-if='scope.row.isEdit'>
							<el-select v-model="scope.row.commissiontype" @change="commissiontypeChange(scope.row)" style="width: 100px;" size='small'>
								<el-option :value="1" label="百分比"></el-option>
								<el-option :value="2" label="固定金额"></el-option>
							</el-select>
						</div>
						<div v-else>
							<span>{{scope.row.commissiontype === 1 ? '百分比' : '固定金额'}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="commissionvalue"
					label="提成金额/百分比"
					align="center"
					min-width="180">
					<template slot-scope="scope">
						<div v-if='scope.row.isEdit'>
							<el-input size="mini" style="width: 150px;" @input='commissionvalueCheck(scope.row)' v-model="scope.row.commissionvalue">
								<template slot="prepend">{{scope.row.commissiontype === 1 ? '%' : '￥'}}</template>
							</el-input>
						</div>
						<div v-else>
							<span>{{scope.row.commissionvalue}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="specCode"
					label="规格编号"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					prop="code"
					label="商品编号"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					prop="bshopcategory"
					label="店铺大类"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					v-if="bigcategoryview === 1"
					prop="sshopcategory"
					label="店铺小类"
					align="center"
					min-width="180">
				</el-table-column>
			</el-table>
		</div>
		<div class="page-box">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page.number"
				:page-sizes="[20, 40, 60, 100, 300]"
				:page-size="page.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
		<div class="foot-btn-box">
			<el-button type="primary" plain size="mini" @click='saveClick'>保存</el-button>
			<el-button type="primary" plain size="mini" @click='cancelProduct'>取消</el-button>
		</div>
		<el-dialog
			title="提示"
			append-to-body
			:visible.sync="showError"
			width="30%">
			<div style="width: 100%;max-height: 300px;overflow-y:auto ;">
				<div style="padding: 5px 10px;" v-for="item in errorList" :key='item'>{{item}}</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size="mini" @click="showError = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: 'addProduct',
	props: {
		commissionPlanId: String,
		customerId: String
	},
	data () {
		return {
			errorList: [],
			showError: false,
			checked: false,
			commissionValue: '',
			commissionType: 2,
			productFilterStr: '',
			specFilterStr: '',
			bc: [],
			sc: [],
			bcId: '0',
			scId: '0',
			bigcategoryview: 0,
			total: 0,
			tableHeight: '100%',
			tableData: [],
			page: {
				number: 1,
				size: 20
			},
			selectIds: []
		}
	},
	created () {
		this.getBigCategory()
		this.checkSmallCategory().then(res => {
			this.bigcategoryview = res.bigcategoryview
		})
		this.tableReolad()
	},
	methods: {
		cancelProduct () {
			this.$emit('cancelProduct')
		},
		checkData () {
			let ids = this.selectIds
			let arr = []
			this.tableData.forEach(item => {
				if (ids.includes(item.attrplanid)) {
					if (item.commissionvalue === '') {
						arr.push('【' + item.productname + '-' + item.spec + '】' + '提成方式不可为空！')
					}
				}
			})
			if (arr.length > 0) {
				this.errorList = arr
				this.showError = true
				return false
			} else {
				return true
			}
		},
		saveClick () {
			if (this.checked) {
				if (this.commissionValue === '') {
					this.$message.error('统一设置提成规则不可为空！')
					return false
				} else {
					this.$emit('saveProduct', this.initSaveData())
				}
			} else {
				if (!this.checkData()) {
					return false
				} else {
					this.$emit('saveProduct', this.initSaveData())
				}
			}
		},
		initSaveData () {
			let ids = this.selectIds
			let arr = []
			this.tableData.forEach(item => {
				if (ids.includes(item.attrplanid)) {
					let row = {
						productName: item.productname,
						productCode: item.code,
						bigCategoryName: item.bshopcategory,
						smallCategoryName: item.sshopcategory,
						productUrl: item.url,
						productId: item.productid,
						productAttrplanId: item.attrplanid,
						commissionType: this.checked ? this.commissionType : item.commissiontype,
						commissionValue: this.checked ? this.commissionValue : item.commissionvalue
					}
					arr.push(row)
				}
			})
			// let params = {
			// 	commissionPlanDetails: arr
			// }
			// if (this.checked) {
			// 	params.commissionType = this.commissionType
			// 	params.commissionValue = this.commissionValue
			// }
			return arr
		},
		commissiontypeChange1 () {
			this.commissionValue = ''
		},
		commissionvalueCheck1 () {
			this.commissionValue = this.commissionValue.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			if (this.commissionType === 1) {
				if (+this.commissionValue >= 1000) {
					this.commissionValue = this.commissionValue.substring(0, 3)
				} else {
					this.commissionValue = this.commissionValue.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				}
			} else {
				if (+this.commissionValue >= 10000) {
					this.commissionValue = this.commissionValue.substring(0, 4)
				} else {
					this.commissionValue = this.commissionValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				}
			}
		},
		commissiontypeChange (item) {
			item.commissionvalue = ''
		},
		commissionvalueCheck (item) {
			item.commissionvalue = item.commissionvalue.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			if (item.commissiontype === 1) {
				if (+item.commissionvalue >= 1000) {
					item.commissionvalue = item.commissionvalue.substring(0, 3)
				} else {
					item.commissionvalue = item.commissionvalue.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				}
			} else {
				if (+item.commissionvalue >= 10000) {
					item.commissionvalue = item.commissionvalue.substring(0, 4)
				} else {
					item.commissionvalue = item.commissionvalue.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				}
			}
		},
		handleSelectionChange (val) {
			let arr = []
			val.forEach(item => {
				arr.push(item.attrplanid)
			})
			this.tableData.forEach(item => {
				if (arr.includes(item.attrplanid)) {
					item.isEdit = true
				} else {
					item.isEdit = false
				}
			})
			this.selectIds = arr
		},
		searchClick () {
			this.page = {
				number: 1,
				size: 20
			}
			this.tableReolad()
		},
		clearClick () {
			this.page = {
				number: 1,
				size: 20
			}
			this.productFilterStr = ''
			this.specFilterStr = ''
			this.bcId = '0'
			this.scId = '0'
			this.tableReolad()
		},
		tableReolad () {
			let params = {
				bigCategoryId: this.bcId,
				smallCategoryId: this.scId,
				productFilterStr: this.productFilterStr,
				specFilterStr: this.specFilterStr,
				commissionPlanId: this.commissionPlanId,
				customerId: this.customerId,
				page: this.page.number,
				size: this.page.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commissionplan/productlist`,
				data: params
			}).then(res => {
				if (res.result) {
					if (res.data.recordList === null) {
						this.tableData = []
					} else {
						this.tableData = this.init(res.data.recordList)
					}
					this.total = res.data.recordCount
				}
			})
		},
		init (list) {
			list.forEach(item => {
				item.isEdit = false
				item.commissionvalue = ''
			})
			return list
		},
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		bcChange (value) {
			this.scId = '0'
			this.bcId = '' + value
			this.getSmalCategory()
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
					this.getSmalCategory()
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReolad()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReolad()
		}
	}
}
</script>

<style lang="stylus" scoped>
.addProduct-container{
	display :flex;
	flex-direction :column;
	padding :10px;
	height:500px;
	.margin10{
		margin-left :10px
	}
	.select-box{
		width :100%;
		height :50px;
		min-height :50px;
		box-sizing:border-box;
		padding :0px 10px;
		display :flex;
		flex-direction :row;
		align-items :center
		.input-box{
			width:150px
		}
	}
	.page-box{
		width :100%;
		margin-top :10px;
		text-align :center
	}
	.table-box{
		flex :1;
		width :100%
	}
	.foot-btn-box{
		height :50px;
		width :100%;
		min-height :50px;
		line-height :50px;
		text-align :center;
	}
}
</style>
<style lang="stylus">
.cell{
	padding :0 !important
}
.addProduct-container{
	.el-dialog__body {
		padding: 0px 0px;
	}
}
</style>
